import { ENDPOINTS as STREAM_ENDPOINTS } from '@polyai/stream/endpoints';

import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { AuditLogEntry } from '../audit/types';

export const getDraftChangeLogs = (
  accountId: string,
  projectId: string,
  branchId?: string,
  limit?: number,
  cursor?: string,
) => {
  return doGet<AuditLogEntry[]>(
    generateNextPath(
      STREAM_ENDPOINTS.BRANCH_AUDIT_LOGS,
      { accountId, projectId, branchId: branchId || 'main' },
      {
        limit: limit?.toString(),
        cursor,
      },
    ),
    LOGGER_TYPE.PROJECT,
    {
      prefix: 'sourcerer',
    },
  );
};

export const getProjectAuditLogs = (
  accountId: string,
  projectId: string,
  limit?: number,
  cursor?: string,
) => {
  return doGet<AuditLogEntry[]>(
    generateNextPath(
      STREAM_ENDPOINTS.PROJECT_AUDIT_LOGS,
      {
        accountId,
        projectId,
      },
      {
        limit: limit?.toString(),
        cursor,
      },
    ),
    LOGGER_TYPE.PROJECT,
    {
      prefix: 'sourcerer',
    },
  );
};

export const getBranchAuditLogs = (
  accountId: string,
  projectId: string,
  branchId: string,
  limit?: number,
  cursor?: string,
) => {
  return doGet<AuditLogEntry[]>(
    generateNextPath(
      STREAM_ENDPOINTS.BRANCH_AUDIT_LOGS,
      {
        accountId,
        projectId,
        branchId,
      },
      {
        limit: limit?.toString(),
        cursor,
      },
    ),
    LOGGER_TYPE.PROJECT,
    {
      prefix: 'sourcerer',
    },
  );
};
